import { Component, Inject, Input, OnDestroy, OnInit, Type } from '@angular/core';
import { IModalWindow, IGetClass } from 'src/app/utils/interfaces/modal-dialog.interface';
import { ModalWindowsTypes } from 'src/app/core/enums';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { ISettings } from 'src/app/core/interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'asg-extraction-options-dialog',
    templateUrl: './extraction-options-dialog.component.html',
    styleUrls: ['./extraction-options-dialog.component.scss'],
    standalone: true,
    imports: [MatCheckboxModule, TranslateModule]
})
export class ExtractionOptionsDialogComponent implements IModalWindow, IGetClass, OnInit, OnDestroy {
  @Input() ok: () => void;
  @Input() no: () => void;
  withColor: boolean;
  withFormatting: boolean;
  sortByColor: boolean;
  settings: ISettings | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ExtractionOptionsDialogComponent>,
    private settingsService: SettingsService,
  ) {
    this.settings = this.settingsService.settings;
  }
  async ngOnDestroy(): Promise<void> {
    await this.settingsService.saveSettings({
      extractSettings: {
        withColor: this.withColor, withFormatting: this.withFormatting,
      }
    });
  }
  ngOnInit(): void {
    this.withColor = this.settings?.extractSettings.withColor ?? true;
    this.withFormatting = this.settings?.extractSettings.withFormatting ?? true;
  }

  getWindowType(): Type<IModalWindow> {
    return ExtractionOptionsDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.EXTRACTION_OPTIONS;
  }

  changeColorOption(isChecked: boolean): void {
    this.withColor = isChecked;
  }

  changeFormattingOption(isChecked: boolean): void {
    this.withFormatting = isChecked;
  }

  changeSortOption(isChecked: boolean): void {
    this.sortByColor = isChecked;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass |null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  getClass(): string {
    return 'extraction-options-dlg';
  }

  closeDlg(): void {
    var data = {
      withColor : this.withColor,
      withFormatting: this.withFormatting,
      sortByColor: this.sortByColor
    }
    this.dialogRef.close(data);
  }
}
